export default __webpack_public_path__ + "static/media/icon_urheilutoiminta_aloitettu.61300e92.svg";